import styles from './KpiDistributionPopover.module.css';

interface DistributionLegendProps {
  plannedLabel: string;
  availableLabel: string;
}

// The key to DistributionBarRow's two bars.
export const DistributionLegend = ({ plannedLabel, availableLabel }: DistributionLegendProps) => (
  <div className={styles.legend}>
    <span className={styles.legendItem}>
      <span className={`${styles.legendDot} ${styles.legendDotPlanned}`} />
      {plannedLabel}
    </span>
    <span className={styles.legendItem}>
      <span className={`${styles.legendDot} ${styles.legendDotRequired}`} />
      {availableLabel}
    </span>
  </div>
);
